<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useMainStore } from "@/store/MainStore.js";
import DashLayout from "@/layouts/DashLayout.vue";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {activateDarkMode} from "@/assets/js/dark-mode";
import {useSettingStore} from "@/store/SettingsStore";

const store = useMainStore();
const settingStore = useSettingStore();

const route = useRoute();

const layout = computed(() => store.layout);
const darkMode = computed(() => store.darkMode);

const currentLayout = computed(() => {
  switch (route.meta.layout) {
    case 'dashboard':
    case 'default':
      return DashLayout;
    case 'auth':
      return AuthLayout;
    default:
      return DashLayout;
  }
});

if (darkMode.value) {
  activateDarkMode();
} else {
  if (settingStore.darkMode) {
    store.toggleDarkMode();
    activateDarkMode();
  }
}
</script>

<template>
  <div v-show="layout === 'landing'" class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>

  <component :is="currentLayout">
    <router-view v-slot="{ Component, route }">
      <transition name="page-transition" mode="out-in">
        <component :is="Component" :key="route.name" />
      </transition>
    </router-view>
  </component>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.page-transition-enter-active,
.page-transition-leave-active {
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.page-transition-enter-from,
.page-transition-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
